import { Variants, Transition } from 'framer-motion';

// Spring presets from spec
export const springs = {
  subtle: { type: 'spring' as const, stiffness: 300, damping: 30 },
  dramatic: { type: 'spring' as const, stiffness: 200, damping: 15 },
  bouncy: { type: 'spring' as const, stiffness: 400, damping: 10 },
} satisfies Record<string, Transition>;

// Page transition variants
export const pageVariants: Variants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0, transition: springs.subtle },
  exit: { opacity: 0, y: 10, transition: { duration: 0.2 } },
};

// Staggered children container
export const staggerContainer: Variants = {
  initial: {},
  animate: {
    transition: { staggerChildren: 0.05 },
  },
};

// Staggered child item
export const staggerItem: Variants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0, transition: springs.subtle },
};

// Slide in from left (leaderboard rows)
export const slideInLeft: Variants = {
  initial: { opacity: 0, x: -30 },
  animate: { opacity: 1, x: 0, transition: springs.subtle },
};

// Shame shake
export const shameShake: Variants = {
  initial: { opacity: 0, rotate: -3 },
  animate: {
    opacity: 1,
    rotate: [0, -2, 2, -1, 1, 0],
    transition: { duration: 0.5, ease: 'easeOut' },
  },
};

// Scale pop (reactions)
export const scalePop = {
  whileTap: { scale: 1.3, transition: springs.bouncy },
};

// Card hover
export const cardHover = {
  whileHover: { y: -2, transition: springs.subtle },
};

// Button press
export const buttonPress = {
  whileHover: { scale: 1.02 },
  whileTap: { scale: 0.97, transition: springs.bouncy },
};
